export default "__VITE_ASSET__ZoPAOBaG__"